<div class="row">
    <div class="col-12 col-md-3">
        <div class="card">
            <div class="card-body"> 
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Banker Group</h3>
                    <div class="mb-3">
                        <label for="name" class="form-label">Name <em>*</em></label>
                        <input type="text" class="form-control" id="name" name="name" #name="ngModel" [(ngModel)]="data.name" required>
                        <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                            <div *ngIf="name.errors.required">Name is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="1">Active</option>
                            <option [value]="0">Disabled</option>
                        </select>
                    </div>
                    <button type="submit" class="btn btn-primary">Submit</button>
                </form>
            </div>
        </div>
    </div>
</div>